/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warrantyImmoGenE2E': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M16 5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-8 8v1a3 3 0 003 3h3a3 3 0 003-3V5.833A3.05 3.05 0 0116 6a3.05 3.05 0 01-1-.167V14a1 1 0 01-1 1h-3a1 1 0 01-1-1V6a3 3 0 00-3-3H4a3 3 0 00-3 3v7.268A2.012 2.012 0 012 13a2 2 0 011 .268V6a1 1 0 011-1h3a1 1 0 011 1v7zm-4 3a2 2 0 11-4 0 2 2 0 014 0z"/>'
  }
})
